import { Component } from '@angular/core';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';
import { MatDialog } from '@angular/material/dialog';
import { SendPaymentInstructionService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.service';
import { CommonMessages } from '@pg-app/shared/constants/common-messages';
import { UtilityService } from '@nttp/common-service/utility-service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';
import { DialogTypeEnum } from '@nttp/enum/common-dialog-type.enum';

@Component({
  selector: 'np-payment-mandate',
  templateUrl: './payment-mandate.component.html',
  styleUrls: ['./payment-mandate.component.scss']
})
export class PaymentMandateComponent {
  constructor(
    public paymentModel: SendPaymentInstructionModelService,
    private dialog: MatDialog,
    private sendPaymentService: SendPaymentInstructionService,
    public utilityService: UtilityService,
    private toastr: ToastrService,
    private router: Router,
  ) {}

  processPayWithMandate() {

    // check beneficiary valid or not base on ticket 2922
    // before send payment to mandate
    const recipientId = this.paymentModel.recipientMandate.id;

    const validateBeneficiary = this.sendPaymentService.validateBeneficiary(recipientId);
    const apiUpdateBankSEPA = this.sendPaymentService.updateBankSEPA({id: recipientId});
    const isAccountOperational = this.utilityService.isAccountOperational();

    forkJoin([isAccountOperational, validateBeneficiary, apiUpdateBankSEPA]).subscribe(res => {
      if (!res[0]) {
        this.toastr.error(CommonMessages.accountNotOperational);
      } else if (!res[2].isSucceeded) {
        this.toastr.error(res[2].error);
      } else if (res[1].length > 0) {
        this.dialog.open(CommonDialogComponent, {
          data: {
            title: CommonMessages.invalidMandate,
            dialogType: DialogTypeEnum.Success,
          },
          disableClose: true
        }).afterClosed().subscribe(() => {
          this.paymentModel.manageRecipientFromPayment = true;
          this.router.navigate(['/client/manage-recipient'], { queryParams: { id: this.paymentModel.recipientMandate.id } });
          this.dialog.closeAll();
        });
      } else {
        this.toProcessPayWithMandate();
      }
    });
  }

  private toProcessPayWithMandate() {
    this.paymentModel.processWithMandate = true;
    const parameter = {
      id: this.paymentModel.recipientMandate.id,
      clientId: null
    };
    this.sendPaymentService.getPaymentBankName(parameter).subscribe(
      res => {
        if (res && res.reference) {
          this.paymentModel.paymentReference = res.reference;
        }
        this.paymentModel.step = this.paymentModel.sendPaymentStep.validatePayment;
      },
      err => {
        this.paymentModel.step = this.paymentModel.sendPaymentStep.validatePayment;
      }
    );
  }

  normalPaymentProcess() {
    this.paymentModel.processWithMandate = false;
    this.paymentModel.step = this.paymentModel.sendPaymentStep.paymentInfo;
  }

  closeDialogAll() {
    this.dialog.closeAll();
    window.location.reload();
  }
}
